import React from "react";
import { Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import {
  Block, Pause, PlayArrow, Warning, Info, Delete as DeleteIcon,
} from "@mui/icons-material";
import { COLORS } from "../../styles/uiConstants";

export default function UserActionsMenu({
  anchorEl,
  user,
  onClose,
  onDetail,
  onAction,
  onDelete,
  canUpdate,
  canDelete,
}) {
  if (!anchorEl) return null;

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      slotProps={{
        paper: {
          sx: { borderRadius: 2.5, boxShadow: "0 8px 32px rgba(15,23,42,0.14)", border: `1px solid ${COLORS.slate200}`, minWidth: 200, py: 0.5 },
        },
      }}
    >
      <ActionItem icon={<Info />} label="Detaylar" color="#3B82F6" textColor="#1E40AF" hoverBg="#EFF6FF" onClick={onDetail} />

      {canUpdate && user?.accountStatus === "Aktif" && (
        <>
          <ActionItem icon={<Warning />} label="Askıya Al" color={COLORS.warning} textColor="#B45309" hoverBg="#FFF7ED" onClick={() => onAction("suspend")} />
          <ActionItem icon={<Pause />} label="Dondur" color="#60A5FA" textColor="#1D4ED8" hoverBg="#EFF6FF" onClick={() => onAction("freeze")} />
          <ActionItem icon={<Block />} label="Devre Dışı Bırak" color={COLORS.error} textColor={COLORS.errorDark} hoverBg={COLORS.errorLightest} onClick={() => onAction("disable")} />
        </>
      )}

      {canUpdate && user?.accountStatus !== "Aktif" && (
        <ActionItem icon={<PlayArrow />} label="Aktifleştir" color={COLORS.success} textColor={COLORS.successDark} hoverBg="#F0FDF4" onClick={() => onAction("activate")} />
      )}

      {canDelete && (
        <ActionItem icon={<DeleteIcon />} label="Kullanıcıyı Sil" color={COLORS.error} textColor={COLORS.errorDark} hoverBg={COLORS.errorLightest} onClick={onDelete} />
      )}
    </Menu>
  );
}

function ActionItem({ icon, label, color, textColor, hoverBg, onClick }) {
  return (
    <MenuItem onClick={onClick} sx={{ py: 1.2, px: 2, mx: 0.5, borderRadius: 1.5, "&:hover": { bgcolor: hoverBg } }}>
      <ListItemIcon sx={{ color, minWidth: 36 }}>{icon}</ListItemIcon>
      <ListItemText primaryTypographyProps={{ fontWeight: 700, fontSize: "0.875rem", color: textColor }}>{label}</ListItemText>
    </MenuItem>
  );
}
